import { render, staticRenderFns } from "./MallList.vue?vue&type=template&id=3e09ff65&scoped=true"
import script from "./MallList.vue?vue&type=script&lang=js"
export * from "./MallList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e09ff65",
  null
  
)

export default component.exports